import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function useHomePageBreadCrumbs() {
    const navigate = useNavigate()

    return {
        jumpClick: () => {
            if (window.location.origin.indexOf('zhumavip') > -1) {
                navigate('/')
            }

            if (window.location.origin.indexOf('zhongheschool') > -1) {
                if (window.location.href.indexOf('/fakao') > -1) {
                    navigate('/fakao')
                } else if (window.location.href.indexOf('/fashuo') > -1) {
                    navigate('/fashuo')
                } else {
                    navigate('/')
                }
            }
        }
    }
}
